import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { UrlMapper } from '@playroomkit/pr-common';

const namespace = ['main'];

export const inittI18n = async (urlMapper: UrlMapper) => {

  const i18nBackendPath = urlMapper.mapUrl(`${import.meta.env.VITE_LOCALES_BASE_URL}/api/locales/{{lng}}/{{ns}}.json`)

  const instance = i18n.createInstance();
  await instance 
    .use(Backend)
    .use(initReactI18next)
    // .use(LanguageDetector)
    .init({
      lng: 'en',
      fallbackLng: {
        default: ['en'],
      },
      backend: {
        loadPath: i18nBackendPath,
      },
      ns: namespace,
      defaultNS: 'main',
      detection: {
        order: [],
        caches: [],
      },
    });

  return instance;
};
